import { render, staticRenderFns } from "./detail_simple.vue?vue&type=template&id=35b0d3cc&scoped=true"
import script from "./detail_simple.vue?vue&type=script&lang=js"
export * from "./detail_simple.vue?vue&type=script&lang=js"
import style0 from "./detail_simple.vue?vue&type=style&index=0&id=35b0d3cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b0d3cc",
  null
  
)

export default component.exports